import { createI18n } from 'vue-i18n'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import texts from 'widget-components/texts/texts.json'

export class TLI18n {
    i18n

    constructor(lang: string) {
        this.i18n = createI18n({
            legacy: false,
            locale: lang,
            fallbackLocale: 'pl',
            messages: texts,
        })
    }
}

let I18N_INSTANCE: TLI18n | null = null

export function createTLI18n(lang: string) {
    if (I18N_INSTANCE) {
        throw new Error('i18n service already created')
    }

    I18N_INSTANCE = new TLI18n(lang)

    return I18N_INSTANCE
}

export function useI18n() {
    if (!I18N_INSTANCE) {
        throw new Error('i18n haven\'t been created')
    }

    return I18N_INSTANCE.i18n.global
}
